import gql from "graphql-tag";
import { fragments as shipmentFragments } from "/imports/api/shipments/apollo/fragments";
import { fragments as invoiceFragments } from "/imports/api/invoices/apollo/fragments";

export const GET_INVOICE = gql`
  query getInvoice($invoiceId: String!) {
    invoice: getInvoice(invoiceId: $invoiceId) {
      ...invoiceWithItems
    }
  }
  ${invoiceFragments.invoiceWithItems}
`;

export const GET_INVOICE_AUDITS = gql`
  query getInvoiceAudits($invoiceId: String!) {
    invoice: getInvoiceAudits(invoiceId: $invoiceId) {
      id
      ...invoiceAudits
    }
  }
  ${invoiceFragments.invoiceAudits}
`;

export const GET_UNINVOICED_SHIPMENTS = gql`
  query getShipmentsWithoutInvoice($invoiceId: String!) {
    shipments: getShipmentsWithoutInvoice(invoiceId: $invoiceId) {
      id
      number
      costs {
        id
        costId
        description
        tooltip
        source
        calculatedExchange
        priceListId
        invoiced
        invoiceId
        amount {
          value
          currency
          rate
          currencyDate
        }
        added {
          by
          at
        }
        accountId
        sellerId
        date
        forApproval
      }
      references {
        number
        carrier
      }
      pickup {
        ...shipmentStop
      }
      delivery {
        ...shipmentStop
      }
      costParams {
        entity
      }
    }
  }
  ${shipmentFragments.shipmentStop}
`;

export const GET_SEARCH_SHIPMENT = gql`
  query getShipmentsBySearch($invoiceId: String!, $query: String!) {
    shipments: getShipmentsBySearch(invoiceId: $invoiceId, query: $query) {
      id
      number
      costs {
        id
        costId
        description
        tooltip
        source
        calculatedExchange
        priceListId
        invoiced
        invoiceId
        amount {
          value
          currency
          rate
          currencyDate
        }
        added {
          by
          at
        }
        accountId
        sellerId
        date
        forApproval
      }
      references {
        number
        carrier
      }
      pickup {
        ...shipmentStop
      }
      delivery {
        ...shipmentStop
      }
    }
  }
  ${shipmentFragments.shipmentStop}
`;

export const ADD_SHIPMENT_COST_ITEMS = gql`
  mutation addShipmentCostItems($input: AddShipmentCostItemInput) {
    addShipmentCostItems(input: $input) {
      ...invoiceWithItems
    }
  }
  ${invoiceFragments.invoiceWithItems}
`;

export const GET_SHIPMENT_COST_DETAIL = gql`
  query getShipmentCostDetailsForInvoice($shipmentId: String!) {
    costDetails: getShipmentCostDetails(shipmentId: $shipmentId) {
      accountId # for security check
      status # for security check
      costDetail {
        baseCurrency
        calculated {
          costId
          source
          amount {
            value
            currency
            rate
          }
          added {
            by
            at
          }
          accountId
          id
          invoiceId
          invoiced
          orgIndex
          description
        }
        invoices {
          # invoiceId
          # FIXME double check this and remove the comments
          id
          number
          sellerId
          date
          subtotal
          costItems {
            id
            description
            amount {
              value
              currency
              rate
            }
            costId
            orgIndex
            source
            invoiceId
            invoiced
          }
        }
        totalShipmentCosts
        totalInvoiceCosts
        totalInvoiceDelta
      }
    }
  }
`;

export const RESET_COST_MAPPING = gql`
  mutation resetInvoiceCostMapping($invoiceId: String!) {
    resetInvoiceCostMapping(invoiceId: $invoiceId) {
      id
      costs {
        code
        description
        costId
      }
    }
  }
`;

export const MAP_INVOICE_COSTS = gql`
  mutation mapInvoiceCosts($input: MapInvoiceCostInput!) {
    mapInvoiceCosts(input: $input) {
      id
      costs {
        code
        description
        costId
      }
    }
  }
`;

export const RESET_EXCHANGE_RATES = gql`
  mutation resetCurrencyExchangeRatesFromInvoice(
    $input: ResetCurrencyExchangeRatesInput!
  ) {
    resetCurrencyExchangeRatesFromInvoice(input: $input)
  }
`;

export const GET_INVOICE_REPORT = gql`
  query getInvoiceReport($query: GetInvoiceReportInput!) {
    getInvoiceReport(query: $query) {
      result
    }
  }
`;

// TODO: field selection after updating invoice
export const UPDATE_INVOICE = gql`
  mutation updateInvoice($input: UpdateInvoiceInput!) {
    updateInvoice(input: $input) {
      id
    }
  }
`;

export const GET_INVOICE_DETAIL = gql`
  query getInvoiceItem($invoiceItemId: String!) {
    invoiceItem: getInvoiceItem(invoiceItemId: $invoiceItemId) {
      ...invoiceItemWithCost
    }
  }
  ${invoiceFragments.invoiceItemWithCost}
`;

export const UPDATE_INVOICE_DETAIL_COST = gql`
  mutation updateInvoiceCostItem($input: UpdateInvoiceCostItemInput!) {
    updateInvoiceCostItem(input: $input) {
      ...invoiceItemWithCost
    }
  }
  ${invoiceFragments.invoiceItemWithCost}
`;

export const SETTLE_INVOICE = gql`
  mutation settleInvoice($invoiceId: String!, $reOpen: Boolean) {
    settleInvoice(invoiceId: $invoiceId, reOpen: $reOpen) {
      id
      status
      ...invoiceUpdates
    }
  }
  ${invoiceFragments.invoiceUpdates}
`;

export const DELETE_INVOICE = gql`
  mutation deleteInvoice($invoiceId: String!) {
    deleteInvoice(invoiceId: $invoiceId) {
      id
      status
      ...invoiceUpdates
    }
  }
  ${invoiceFragments.invoiceUpdates}
`;

export const OFFER_INVOICE = gql`
  mutation offerInvoice($input: OfferInvoiceInput!) {
    offerInvoice(input: $input) {
      id
      status
      ...invoiceUpdates
    }
  }
  ${invoiceFragments.invoiceUpdates}
`;

export const DELETE_INVOICE_ITEM = gql`
  mutation deleteInvoiceItem($invoiceItemId: String!) {
    deleteInvoiceItem(invoiceItemId: $invoiceItemId)
  }
`;

export const REVOKE_INVOICE = gql`
  mutation revokeInvoice($input: RevokeInvoiceInput!) {
    revokeInvoice(input: $input) {
      id
      status
      ...invoiceUpdates
    }
  }
  ${invoiceFragments.invoiceUpdates}
`;

export const RUN_INVOICE_AUDITS = gql`
  mutation runInvoiceAudits($invoiceId: String!) {
    runInvoiceAudits(invoiceId: $invoiceId)
  }
  
`;

export const RUN_INVOICE_DENORMALIZATION = gql`
  mutation refreshInvoiceDenormalization($invoiceId: String!){
    refreshInvoiceDenormalization(invoiceId: $invoiceId)
  }
`